define(function (require) {
	const IpsModel = require('civicsBase/ipsModel');

	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/property/agencymaps/{0}',
		url: function () {
			return this.urlRoot.format(this.mapName);
		},
		parse: function (response) {
			var ret = {};
			if (response.data) {
				var data = response.data;
				ret.allData = data;
				if (data.Map && data.Map.Options && data.Map.Options.Values && data.Map.Options.Values.length>0) {
					_.forEach(data.Map.Options.Values, (item) => {
						if (item.id == 'extent') {
							if (item.value) {
								//remove all spaces from the extent
								ret.extent = item.value.replace(/\s+/g, '');
							}
						}
					});
				}
			}
			return ret;
		}
	});
});
